<template>
  <div id="divContainer" v-on:click="exitmenu" class="page-effect">
    <!-- <TopMenu /> -->
    <section id="sectionId" class="sponsors-list-wrapper d-flex body-content">
      <!--@click="onClickHandler"-->

      <div class="container-fluid left-right-common-gap">
        <!------top area start--->
        <div class="row">
          <div class="col-md-6 mb-22">
            <h1 id="headerText" class="page-head text-uppercase mb-0">Sponsors</h1>
          </div>
          <div class="col-md-6 new-addendee-list">
            <div class="row justify-content-end">
              <!-- <div class="position-relative fixed-w full-width search-hld">
                 <form id="newsletter-validate-detail" class="form subscribe" action method>
                <input id="filter" type="text" placeholder="Search..." />
                <button class="sub-btn" type="submit">Subscribe</button>
                </form>
              </div>-->
              <!-----filter start---->
              <!-- <div class="dropdown">
                <button
                  class="ad-btn d-lg-inline-block dropdown-toggle"
                  type="button"
                  id="dropdownMenu2"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-tag="SponsorsFilter"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30px"
                    height="30px"
                    viewBox="0 0 16.5 15"
                  >
                    <path
                      id="filter.svg"
                      fill="#242432"
                      d="M181.241,159.157c0,0.013,0,.025,0,0.037a0.532,0.532,0,0,1,.006.056,0.744,0.744,0,0,1-.284.583L175.25,166.3v6.453h-0.011a0.713,0.713,0,0,1-.082.366,0.747,0.747,0,0,1-1.005.3l-3.023-1.532a0.715,0.715,0,0,1-.368-0.631H170.75V166.3l-5.716-6.463a0.747,0.747,0,0,1-.284-0.584,0.523,0.523,0,0,1,.006-0.057c0-.012,0-0.023,0-0.034a0.736,0.736,0,0,1,.066-0.23c0.008-.017.017-0.033,0.027-0.05A0.722,0.722,0,0,1,165,158.7c0.007-.007.01-0.016,0.018-0.023s0.018-.008.027-0.015a0.748,0.748,0,0,1,.208-0.113l0.057-.017a0.705,0.705,0,0,1,.191-0.028h15a0.705,0.705,0,0,1,.191.028c0.02,0,.038.011,0.058,0.018a0.722,0.722,0,0,1,.206.112c0.009,0.007.02,0.008,0.028,0.015s0.011,0.016.019,0.023a0.75,0.75,0,0,1,.145.182c0.01,0.017.02,0.034,0.029,0.052A0.76,0.76,0,0,1,181.241,159.157Zm-9.172,6.377a0.716,0.716,0,0,1,.169.466h0.012v4.791l1.5,0.76V166h0.012a0.716,0.716,0,0,1,.169-0.466L178.825,160h-11.65Z"
                      transform="translate(-164.75 -158.5)"
                    />
                  </svg>
                  <span class="cart-item" style="display:none;"></span>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                  <ul class="filter-listing clearfix remember" id="dropFilter"></ul>
                </div>
              </div>-->
              <!-----filter end---->
              <div class="col-md-4 mb-3 mb-md-0 pl-md-1 comm-width-fillter-new">
                <div class="position-relative fixed-w full-width filter-hld">
                  <select>
                    <option value="All">All</option>
                    <option>Group1</option>
                    <option>Group2</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!------top area end---->
        <h3 class="text-center">
          <span id="spnHeaderText"></span>
        </h3>
        <div class="sponsors-inner-hld">
          <div id="divMainiRow">
            <!---category row start------->
            <div class="row attendee-list-box-wrapper new-sponsorlist-r platinum-row">
              <!-------headding-->
              <div class="col-md-12">
                <h5 class="category-head platinum-sponsor">Platinum</h5>
              </div>
              <!-------headding-->
              <hooper :itemsToShow="3" :itemsToSlide="1" :progress="true" :playSpeed="2000">
                <slide>
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSponsors%2FAR.png?alt=media"
                        alt="ACTIONRICH Business Solutions (India) Pvt Ltd."
                      />
                    </span>
                  </div>
                </slide>
                <slide>
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSponsors%2FAR.png?alt=media"
                        alt="ACTIONRICH Business Solutions (India) Pvt Ltd."
                      />
                    </span>
                  </div>
                </slide>
                <slide>
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSponsors%2FAR.png?alt=media"
                        alt="ACTIONRICH Business Solutions (India) Pvt Ltd."
                      />
                    </span>
                  </div>
                </slide>
                <slide>
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSponsors%2FAR.png?alt=media"
                        alt="ACTIONRICH Business Solutions (India) Pvt Ltd."
                      />
                    </span>
                  </div>
                </slide>
                <slide>
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSponsors%2FAR.png?alt=media"
                        alt="ACTIONRICH Business Solutions (India) Pvt Ltd."
                      />
                    </span>
                  </div>
                </slide>
                <slide>
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSponsors%2FAR.png?alt=media"
                        alt="ACTIONRICH Business Solutions (India) Pvt Ltd."
                      />
                    </span>
                  </div>
                </slide>
                <slide>
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSponsors%2FAR.png?alt=media"
                        alt="ACTIONRICH Business Solutions (India) Pvt Ltd."
                      />
                    </span>
                  </div>
                </slide>
                <hooper-navigation slot="hooper-addons"></hooper-navigation>
              </hooper>
            </div>
            <!---category row end------->
            <!---category row start GOLD------->
            <div class="row attendee-list-box-wrapper new-sponsorlist-r gold-row">
              <!-------headding-->
              <div class="col-md-12">
                <h5 class="category-head gold-sponsor">Gold</h5>
              </div>
              <!-------headding-->

              <hooper :itemsToShow="6" :itemsToSlide="2" :progress="true" :playSpeed="2000">
                <slide>
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSponsors%2FAR.png?alt=media"
                        alt="ACTIONRICH Business Solutions (India) Pvt Ltd."
                      />
                    </span>
                  </div>
                </slide>
                <slide>
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSponsors%2FAR.png?alt=media"
                        alt="ACTIONRICH Business Solutions (India) Pvt Ltd."
                      />
                    </span>
                  </div>
                </slide>
                <slide>
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSponsors%2FAR.png?alt=media"
                        alt="ACTIONRICH Business Solutions (India) Pvt Ltd."
                      />
                    </span>
                  </div>
                </slide>
                <slide>
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSponsors%2FAR.png?alt=media"
                        alt="ACTIONRICH Business Solutions (India) Pvt Ltd."
                      />
                    </span>
                  </div>
                </slide>
                <slide>
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSponsors%2FAR.png?alt=media"
                        alt="ACTIONRICH Business Solutions (India) Pvt Ltd."
                      />
                    </span>
                  </div>
                </slide>
                <slide>
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSponsors%2FAR.png?alt=media"
                        alt="ACTIONRICH Business Solutions (India) Pvt Ltd."
                      />
                    </span>
                  </div>
                </slide>
                <slide>
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSponsors%2FAR.png?alt=media"
                        alt="ACTIONRICH Business Solutions (India) Pvt Ltd."
                      />
                    </span>
                  </div>
                </slide>
                <slide>
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSponsors%2FAR.png?alt=media"
                        alt="ACTIONRICH Business Solutions (India) Pvt Ltd."
                      />
                    </span>
                  </div>
                </slide>
                <slide>
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSponsors%2FAR.png?alt=media"
                        alt="ACTIONRICH Business Solutions (India) Pvt Ltd."
                      />
                    </span>
                  </div>
                </slide>
                <hooper-navigation slot="hooper-addons"></hooper-navigation>
              </hooper>
            </div>
            <!---category row end------->
            <!---category row start GOLD------->
            <div class="row attendee-list-box-wrapper new-sponsorlist-r silver-row">
              <!-------headding-->
              <div class="col-md-12">
                <h5 class="category-head Silver-sponsor">Silver</h5>
              </div>
              <!-------headding-->

              <hooper :itemsToShow="8" :itemsToSlide="2" :progress="true" :playSpeed="2000">
                <slide>
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSponsors%2FAR.png?alt=media"
                        alt="ACTIONRICH Business Solutions (India) Pvt Ltd."
                      />
                    </span>
                  </div>
                </slide>
                <slide>
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSponsors%2FAR.png?alt=media"
                        alt="ACTIONRICH Business Solutions (India) Pvt Ltd."
                      />
                    </span>
                  </div>
                </slide>
                <slide>
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSponsors%2FAR.png?alt=media"
                        alt="ACTIONRICH Business Solutions (India) Pvt Ltd."
                      />
                    </span>
                  </div>
                </slide>
                <slide>
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSponsors%2FAR.png?alt=media"
                        alt="ACTIONRICH Business Solutions (India) Pvt Ltd."
                      />
                    </span>
                  </div>
                </slide>
                <slide>
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSponsors%2FAR.png?alt=media"
                        alt="ACTIONRICH Business Solutions (India) Pvt Ltd."
                      />
                    </span>
                  </div>
                </slide>
                <slide>
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSponsors%2FAR.png?alt=media"
                        alt="ACTIONRICH Business Solutions (India) Pvt Ltd."
                      />
                    </span>
                  </div>
                </slide>
                <slide>
                  <div class="sponsors-box-hld text-center sponsorpanel">
                    <span class="logo-area">
                      <img
                        src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1591904892446E1591907102804%2FSponsors%2FAR.png?alt=media"
                        alt="ACTIONRICH Business Solutions (India) Pvt Ltd."
                      />
                    </span>
                  </div>
                </slide>
                <hooper-navigation slot="hooper-addons"></hooper-navigation>
              </hooper>
            </div>
            <!---category row end------->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import carousel from "vue-owl-carousel";
import { Hooper, Slide, Navigation as HooperNavigation } from "hooper";
import "hooper/dist/hooper.css";
export default {
  // components: { carousel },
  components: {
    Hooper,
    Slide,
    HooperNavigation,
  },
};
</script>